module.exports = __webpack_public_path__ + "static/media/galerija_2022_0012.d4d65e80.jpg";